/**
 * Immigration & Travel Law hub — global subcategory registry.
 */
import { IMMIGRATION_TRAVEL_LAW_SLUG, immigrationTravelLawDefaultData } from "./immigrationTravelLawData";
import {
  ImmigrationTravelLawArticlesTab,
  ImmigrationTravelLawMediaTab,
  ImmigrationTravelLawOverviewTab,
} from "./ImmigrationTravelLawDesign";

export const immigrationTravelLawModule = {
  slug: IMMIGRATION_TRAVEL_LAW_SLUG,
  getDefaultData: () => immigrationTravelLawDefaultData,
  Views: {
    overview: ImmigrationTravelLawOverviewTab,
    articles: ImmigrationTravelLawArticlesTab,
    media: ImmigrationTravelLawMediaTab,
  },
};
